/* 
 * Export component file to be used on project
*/

import  Questionnaire from './Questionnaire.js';
export default  Questionnaire;